export default __webpack_public_path__ + "static/kalina_tyrkiel-20f3bf8463b9ac93c61caeaa2af91315.jpg";